var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManageFields = function SvgManageFields(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 194.61",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 21.18,
    y1: 178.81,
    x2: 193.65,
    y2: 6.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 15.81,
    y1: 173.45,
    x2: 188.28,
    y2: 0.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 27.06,
    y1: 184.69,
    x2: 199.53,
    y2: 12.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -17.75,
    y1: 139.89,
    x2: 154.72,
    y2: -32.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 17.01,
    y1: 174.64,
    x2: 189.47,
    y2: 2.17,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M198.66,20.14L179.87,1.38c-1.85-1.84-4.84-1.84-6.69,0l-66.42,66.42c-.5.52-.88,1.14-1.11,1.83l-9.82,28.56c-.58,1.71-.14,3.61,1.14,4.89.89.89,2.09,1.39,3.34,1.4.55,0,1.09-.08,1.61-.26l28.47-9.84c.68-.23,1.3-.62,1.8-1.14L198.61,26.81c1.84-1.83,1.86-4.81.05-6.67ZM126.43,85.66l-.1.1-18.38,6.31,6.33-18.36,46.87-46.87.04.04.04-.04,12.05,12.05-46.85,46.78ZM179.92,32.17l-12.05-12.05,8.66-8.68,12.05,12.07-8.66,8.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.09,80.75c-2.62,0-4.74,2.12-4.74,4.74v99.63H9.49V28.56h121.24c2.62,0,4.74-2.12,4.74-4.74s-2.12-4.74-4.74-4.74H4.74c-2.62,0-4.74,2.12-4.74,4.74v166.05c0,2.62,2.12,4.74,4.74,4.74h155.35c2.62,0,4.74-2.12,4.74-4.74v-104.37c0-2.62-2.12-4.74-4.74-4.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.81,138.56c-8.01.01-14.5,6.5-14.52,14.52v2.37c.01,8.01,6.51,14.5,14.52,14.52h39.35c8.01-.01,14.5-6.51,14.52-14.52v-2.37c-.01-8.01-6.51-14.5-14.52-14.52h-39.35ZM82.19,153.07v2.37c0,2.78-2.25,5.03-5.03,5.03h-39.35c-2.78,0-5.03-2.25-5.03-5.03v-2.37c0-2.78,2.25-5.03,5.03-5.03h39.35c2.78,0,5.03,2.25,5.03,5.03Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.11,56.96c2.62,0,4.74-2.12,4.74-4.74s-2.12-4.74-4.74-4.74H28.04c-2.62,0-4.74,2.12-4.74,4.74v23.96c0,2.62,2.12,4.74,4.74,4.74h59.82c2.62,0,4.74-2.12,4.74-4.74s-2.12-4.74-4.74-4.74h-55.08v-14.47h72.33Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.52,121.22v-12.64c0-2.62-2.12-4.74-4.74-4.74s-4.74,2.12-4.74,4.74v7.9H32.78v-14.47h48.98c2.62,0,4.74-2.12,4.74-4.74s-2.12-4.74-4.74-4.74H28.04c-2.62,0-4.74,2.12-4.74,4.74v23.96c0,2.62,2.12,4.74,4.74,4.74h108.74c2.62,0,4.74-2.12,4.74-4.74Z"
  })));
};
export default SvgManageFields;